"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLastPageRenderer = exports.DefaultNextPageRenderer = exports.DefaultPageRenderer = exports.DefaultPreviousPageRenderer = exports.DefaultFirstPageRenderer = void 0;
const react_1 = __importDefault(require("react"));
const Paginator_styles_1 = require("./Paginator.styles");
const styles_1 = require("../../styles");
const ICON_SIZE = '1em';
const ALT_ICON_SIZE = '1.5em';
const DefaultFirstPageRenderer = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Paginator_styles_1.PageIconWrapper, { "aria-hidden": "true" },
        react_1.default.createElement(Paginator_styles_1.FirstPageIcon, { size: ICON_SIZE })),
    react_1.default.createElement(styles_1.VisuallyHidden, null, "First page")));
exports.DefaultFirstPageRenderer = DefaultFirstPageRenderer;
const DefaultPreviousPageRenderer = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Paginator_styles_1.PageIconWrapper, { "aria-hidden": "true" },
        react_1.default.createElement(Paginator_styles_1.PreviousPageIcon, { size: ALT_ICON_SIZE })),
    react_1.default.createElement(styles_1.VisuallyHidden, null, "Previous page")));
exports.DefaultPreviousPageRenderer = DefaultPreviousPageRenderer;
const DefaultPageRenderer = (page) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(styles_1.VisuallyHidden, null, "Page"),
    page.label));
exports.DefaultPageRenderer = DefaultPageRenderer;
const DefaultNextPageRenderer = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Paginator_styles_1.PageIconWrapper, { "aria-hidden": "true" },
        react_1.default.createElement(Paginator_styles_1.NextPageIcon, { size: ALT_ICON_SIZE })),
    react_1.default.createElement(styles_1.VisuallyHidden, null, "Next page")));
exports.DefaultNextPageRenderer = DefaultNextPageRenderer;
const DefaultLastPageRenderer = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Paginator_styles_1.PageIconWrapper, { "aria-hidden": "true" },
        react_1.default.createElement(Paginator_styles_1.LastPageIcon, { size: ICON_SIZE })),
    react_1.default.createElement(styles_1.VisuallyHidden, null, "Last page")));
exports.DefaultLastPageRenderer = DefaultLastPageRenderer;
//# sourceMappingURL=Renderers.js.map